import { render } from "./PremiumDiscountCalculationDetail.vue?vue&type=template&id=24220b62"
import script from "./PremiumDiscountCalculationDetail.vue?vue&type=script&lang=js"
export * from "./PremiumDiscountCalculationDetail.vue?vue&type=script&lang=js"

import "./PremiumDiscountCalculationDetail.vue?vue&type=style&index=0&id=24220b62&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__